<template>
  <div class="paribu-solutions">
    <NuxtLink
      v-for="(item, index) in items"
      :key="`paribuSolutionsKey--${index}`"
      :to="item.link ? item.link : '#'"
      class="paribu-solutions__item"
    >
      <div class="paribu-solutions__item--icon">
        <NuxtImg :src="item.icon" :alt="item.heading" />
      </div>

      <div class="paribu-solutions__item--body">
        <div class="paribu-solutions__item--body__heading">
          {{ item.heading }}
        </div>

        <div class="paribu-solutions__item--body__description">
          {{ item.description }}
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
interface Item {
  icon: string
  heading: string
  description: string
  link?: string
}

defineProps({
  items: {
    type: Array as () => Item[],
    required: true,
  },
})
</script>
